import { verifySteps } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function VerifySteps() {
  return (
    <section id="guide" className="w-full bg-background-50">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <SectionHeading
            index="02"
            kicker="辨别指南"
            title="五步辨别真假，一步都别跳"
            desc="真假辨别不需要多高深的技术，只需要按顺序核对。多数钓鱼网站撑不过前两步，剩下的三步则是给「看起来很像」的高仿站准备的。"
          />
          <div className="mt-8 flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5">
            <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-lightbulb-flash-line text-xl" />
            </span>
            <p className="text-sm leading-relaxed text-foreground-700">
              核对时不要只看一眼就通过，把域名、排版、跳转三处逐一确认，才算走完辨别流程。
            </p>
          </div>
        </div>

        <ol className="flex flex-col divide-y divide-background-200 border-y border-background-200">
          {verifySteps.map((step) => (
            <li key={step.no} className="group flex items-start gap-5 py-6 md:gap-8 md:py-7">
              <span className="font-heading text-3xl font-black leading-none text-background-400 transition-colors group-hover:text-accent-500 md:text-4xl">
                {step.no}
              </span>
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}